import { createFileRoute, Link } from '@tanstack/react-router'
import { Provider } from 'jotai'
import ArrowBack from '~icons/material-symbols/arrow-back.svg'

import { contentWrapper } from '../../../../styles/contentWrapper'
import { pageTitle, sectionTitle, sectionWrapper, titleWrapper } from '../../../../styles/sectionStyles'
import { css } from '../../../../../styled-system/css'
import { ApplyChanges } from './-components/apply-changes'
import { CsvErrorViewer } from './-components/error-viewer'
import { Instructions } from './-components/instructions'
import { Loader } from './-components/loader'
import { TemplateDownloader } from './-components/template-downloader'

export const Route = createFileRoute('/admin/points/bulkCreateStandaloneDistributionCodes/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Provider>
      <div className={contentWrapper()}>
        <div className={titleWrapper()}>
          <h1 className={pageTitle()}>
            <Link to='/admin/points'>
              <ArrowBack />
            </Link>
            配布コード一括作成
          </h1>
        </div>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          })}
        >
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>テンプレートをダウンロード</div>
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              })}
            >
              <p>CSVテンプレートをダウンロードし、必要な列を入力してください。</p>
              <TemplateDownloader />
            </div>
          </div>
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>操作方法</div>
            <Instructions />
          </div>
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>データを読み込み</div>
            <Loader />
            <CsvErrorViewer />
          </div>
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>一括作成</div>
            <ApplyChanges />
          </div>
        </div>
      </div>
    </Provider>
  )
}
